import QuestionFieldCreationForm from "pages/ManagementPage/candidateInfoForm/QuestionFieldCreationForm/QuestionFieldCreationForm";

export default QuestionFieldCreationForm;
